import { useContext, useLayoutEffect, useState } from 'react';
import { StackedDialogContext } from './stackedDialog.context';

/**
 * While `opened`, covers the dialog that hosts stacked dialogs (`useStackedDialogHost`), so Escape and outside clicks
 * close only what is open over it. It takes effect in the commit that opens, before any later key event can reach the
 * dialog beneath.
 */
export const useStackedDialogCover = (opened: boolean) => {
	const stackHost = useContext(StackedDialogContext);
	useLayoutEffect(
		() => (opened && stackHost ? stackHost.cover() : undefined),
		[opened, stackHost]
	);
};

/** Open state for a menu inside such a dialog, covering it while open: spread onto Mantine's `Menu`. */
export const useCoveredMenu = () => {
	const [opened, setOpened] = useState(false);
	useStackedDialogCover(opened);
	return { opened, onChange: setOpened };
};
